module.exports = __webpack_public_path__ + "explore/images/eoy/bathtub-2x.38b9e66da4021231bd475e3de90e1f26.png";